"use strict";
export const calculateLtv = (creditAmount, collateralAmount) => {
  return (creditAmount / collateralAmount * 100).toFixed(2);
};
